<template>
    <div>
        <v-row class="flex">
            <v-container
                style="width:60%"
                v-if="schedule.if_needed_option === 'no'"
            >
            <p>Username:{{schedule.username}}</p>
                <noifneeded v-bind:store="store" />
            </v-container>
            <v-container style="width:60%" v-else>
                <ifneeded v-bind:store="store" />
            </v-container>
            <v-container style="width:20%">
                <adds :theme="schedule.theme" />
            </v-container>
        </v-row>
    </div>
</template>

<script>
import store from "../../store";
import noifneeded from "./participants/noifneeded";
import ifneeded from "./participants/ifneeded";
import adds from "../ads";
export default {
    components: {
        noifneeded,
        ifneeded,
        adds
    },
    data: function() {
        return {
            store: store,
            link: this.$route.params.link,
            schedule: null
        };
    },
    created: async function() {
        var bodyForm = new FormData();
        bodyForm.set("link", this.link);
        var config = {
            method: "post",
            url: "",
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            },
            data: bodyForm
        };
        await this.store.dispatch("getScheduleDetails", config);
        this.schedule = this.store.state.getSchedule.details[0];
    }
};
</script>

<style></style>
